<template>
    <div class="counter" :class="{ 'animate': this.animate }">
        <span class="number" v-text="number"></span>
        <span class="text" v-text="text"></span>
    </div>
</template>
<script>
    export default {
        props: ['number', 'text'],
        data() {
            return {
                bounding: null,
                callback: this.zoom.bind(this),
                animate: false
            }
        },
        mounted() {
            document.addEventListener('scroll', this.callback)
        },
        methods: {
            inViewport() {
                let bounding = this.$el.getBoundingClientRect();
                return (
                    bounding.top <= window.innerHeight - bounding.height &&
                    bounding.y >= bounding.height
                )
            },
            zoom() {
                if( ! this.inViewport() ) return;

                this.animate = true
                setTimeout( () => {
                    this.animate = false
                    document.removeEventListener('scroll', this.callback)
                }, 250 )
            }
        }
    }
</script>